import _ from 'lodash';

function getCoverageDisplayName(coverage) {
    const coverageName = _.trim(_.get(coverage, 'name', ''));
    const coverageCode = _.trim(_.get(coverage, 'code', ''));

    if (!coverageName) {
        return '';
    }

    if (coverageCode) {
        const prefixedCoveragePattern = new RegExp(`^${_.escapeRegExp(coverageCode)}\\s*-\\s*`, 'i');
        return coverageName.replace(prefixedCoveragePattern, '').trim();
    }

    return coverageName.replace(/^[A-Z0-9_]{2,10}\s*-\s*/, '').trim();
}

function formatAdjusterPhoneNumber(adjuster, format) {
    let number = '';
    if (adjuster.phoneNumberExtension) {
        number = number.concat(adjuster.phoneNumber, format, adjuster.phoneNumberExtension);
    } else {
        number = adjuster.phoneNumber;
    }
    return number;
}

function getDisplayablePhoneNumberWithExtension(adjuster) {
    return formatAdjusterPhoneNumber(adjuster, ' ext');
}

function getAdjusters(data) {
    const adjusters = data?.lobs?.personalAuto?.adjusters_WMIC || [];

    _.each(adjusters, (adjuster) => {
        _.set(adjuster, 'phoneNumberDisplayable', getDisplayablePhoneNumberWithExtension(adjuster));
    });

    return adjusters;
}

function getListAdjusterCoverages(adjuster) {
    const coverages = adjuster?.coverages || [];
    if (coverages?.length > 0) {
        const displayableCoverageNames = _.chain(coverages)
            .map((coverage) => getCoverageDisplayName(coverage))
            .filter((coverageName) => !_.isEmpty(coverageName))
            .value();

        if (_.isEmpty(displayableCoverageNames)) {
            return [];
        }

        let displayableCoverages = [];
        _.each(displayableCoverageNames, (coverageName, index) => {
            displayableCoverages = displayableCoverages.concat(coverageName);
            if (index < displayableCoverageNames.length - 1) {
                displayableCoverages = displayableCoverages.concat(', ');
            }
        });
        return displayableCoverages;
    }
    return [];
}

export default {
    formatAdjusterPhoneNumber,
    getDisplayablePhoneNumberWithExtension,
    getAdjusters,
    getListAdjusterCoverages
};